import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { Button } from "./ui/button";

const links = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-lg"
      data-testid="site-header"
    >
      <div className="container mx-auto flex h-20 max-w-7xl items-center justify-between px-6 md:px-12">
        <a href="#top" data-testid="header-logo-link">
          <Logo />
        </a>

        <nav className="hidden items-center gap-10 md:flex" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-[Outfit] text-sm font-medium uppercase tracking-wider text-foreground/70 transition hover:text-primary"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:7353626623"
            className="hidden items-center gap-2 text-sm font-semibold text-foreground md:flex"
            data-testid="header-phone-link"
          >
            <Phone className="h-4 w-4 text-primary" />
            73536 26623
          </a>
          <Button
            asChild
            className="hidden rounded-none bg-primary font-[Outfit] font-semibold uppercase tracking-wider hover:bg-primary/90 md:inline-flex"
            data-testid="header-cta-button"
          >
            <a href="#contact">Book Consultation</a>
          </Button>

          <button
            className="flex h-10 w-10 items-center justify-center border border-border md:hidden"
            onClick={() => setOpen((s) => !s)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden border-t border-border bg-background md:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-1 p-6">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-3 font-[Outfit] text-sm font-medium uppercase tracking-wider text-foreground/80 hover:text-primary"
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              ))}
              <a
                href="tel:7353626623"
                className="mt-2 flex items-center gap-2 py-3 text-sm font-semibold text-primary"
                data-testid="mobile-phone-link"
              >
                <Phone className="h-4 w-4" /> Call 73536 26623
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
